import React, { useEffect, useState } from "react";
import "../CityPage/citypage.css";
import HomeService from "../../Services/HomeService";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import AdvertisingBanner from "./AdvertisingBanner";
import ExploreTopCities from "./ExploreTopCities";
import LocationInsig from "../WinnersHome/LocationInsig";
import AboutCommunity from "./AboutCommunity";
import Header from "../../Layout/Header";
import Header2 from "../../Layout/Header2";

function CityPage() {
  const [cityDetails, setCityDetails] = useState({});
  const [reelsForCity, setReelsForCity] = useState([]);
  const location = useLocation();
  const id = location?.state?.id || "";
  const navigate = useNavigate();

  const fetchCityDetilsById = async () => {
    try {
      const res = await HomeService.getCityDetailsById(
        // "68720cc572a330fae27b2421"
        id,
      );
      if (res?.status) {
        setCityDetails(res?.data);
      } else {
        // toast.error(res?.message);
        console.log(res?.data);
      }
      console.log("CITY DETAILS", res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReelsByCityId = async () => {
    try {
      const res = await HomeService.getReelsByCityId(
        // "68720cc572a330fae27b2421"
        id,
      );
      if (res?.status) {
        setReelsForCity(res?.data);
      } else {
        // toast.error(res?.message);
        console.log(res?.data);
      }
      console.log("REELS DETAILS", res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCityDetilsById();
    fetchReelsByCityId();
    window.scroll(0, 0);
  }, [id]);

  const problems = [
    {
      id: 1,
      icon: <i class="fa-solid fa-phone-slash"></i>,
      title: "Problem #1",
      text: "Fake owner numbers that waste time",
    },
    {
      id: 2,
      icon: <i class="fa-solid fa-triangle-exclamation"></i>,
      title: "Problem #2",
      text: "Unverified property listings",
    },
    {
      id: 3,
      icon: <i class="fa-solid fa-xmark"></i>,
      title: "Problem #3",
      text: "Endless & unproductive calls",
    },
    {
      id: 4,
      icon: <i class="fa-solid fa-database"></i>,
      title: "Problem #4",
      text: "Old, worthless data",
    },
    {
      id: 5,
      icon: <i class="fa-solid fa-users"></i>,
      title: "Problem #5",
      text: "Extreme competition",
    },
    {
      id: 6,
      icon: <i class="fa-solid fa-building"></i>,
      title: "Problem #6",
      text: "No direct builder connections",
    },
  ];

  const brokerdata = [
    {
      id: 1,
      icon: <i class="fa-solid fa-phone-slash"></i>,
      title: "Verified Data",
      text: "Real estate data you can trust,verified daily",
    },
    {
      id: 2,
      icon: <i class="fa-solid fa-triangle-exclamation"></i>,
      title: "Fresh Contact",
      text: "Owner contacts updated every single day",
    },
    {
      id: 3,
      icon: <i class="fa-solid fa-xmark"></i>,
      title: "Builder Tie-ups",
      text: "Genuine builder connections across Gurugram",
    },
    {
      id: 4,
      icon: <i class="fa-solid fa-database"></i>,
      title: "premium Inventory",
      text: "Inventory across all premium & mid segment sectors",
    },
    {
      id: 5,
      icon: <i class="fa-solid fa-users"></i>,
      title: "High-intent leads",
      text: "Buyer and tenant leads that actually convert.",
    },
    {
      id: 6,
      icon: <i class="fa-solid fa-building"></i>,
      title: "Real Closings",
      text: "A platform designed for closing deals,not confusion.",
    },
  ];

  const testimonials = [
    {
      name: "Rahul Sharma",
      role: "Real Estate Broker",
      review:
        "This platform completely changed how I get property leads. Super accurate data and zero fake numbers.",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      name: "Anita Verma",
      role: "Agent, Gurugram",
      review:
        "Amazing experience! The quality of leads is far better than any other service I used before.",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      name: "Vikram Singh",
      role: "Independent Broker",
      review:
        "Finally a platform that actually helps brokers instead of wasting our time. Highly recommended!",
      image: "https://randomuser.me/api/portraits/men/40.jpg",
    },
  ];

  const stats = [
    { number: "1200+", label: "Brokers Registered" },
    { number: "10000+", label: "Verified Inventories" },
    { number: "68+", label: "Sectors Covered" },
    { number: "90000+", label: "Daily Searches" },
  ];

  const steps = [
    {
      icon: <i class="fa-solid fa-magnifying-glass"></i>,
      title: "Verified Inventory",
      text: "Premium listings onboarded",
    },
    {
      icon: <i class="fa-regular fa-handshake"></i>,
      title: "Direct Connections",
      text: "Access builders & owners",
    },
    {
      icon: <i class="fa-solid fa-users"></i>,
      title: "Resale Sharing",
      text: "List & explore inventory",
    },
    {
      icon: <i class="fa-solid fa-chart-line"></i>,
      title: "Lead Management",
      text: "Track deals seamlessly",
    },
  ];

  const [index, setIndex] = useState(0);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // Auto slide every 4 seconds
  useEffect(() => {
    const timer = setInterval(nextSlide, 10000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="citypage_container">
      <div style={{ position: "sticky", top: "0px", zIndex: "1000" }}>
        <Header2 />
      </div>
      <div
        className="hero-container"
        style={{
          background: `url(${cityDetails?.firstSection?.image}) center/cover no-repeat`,
        }}
      >
        {/* <nav className={`navbar ${isSticky ? "navbar-sticky" : ""}`}>
          <div className="navbar-items city-uni-container">
            <div
              className="logo"
              onClick={() => {
                navigate("/");
              }}
              style={{ cursor: "pointer" }}
            >
              TheWinners2 <span>.in</span>
            </div>
            <div className="logo_ul">
              <ul className="nav-menu">
                <li
                  onClick={() => {
                    navigate("/");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Home
                </li>
                <li>Services</li>
                <li
                  onClick={() => {
                    navigate("/aboutus");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  About
                </li>
                <li>Contact</li>
              </ul>
              <button
                onClick={() => {
                  navigate("/profile");
                }}
                className="register-btn-city-nav"
              >
                Register Now
              </button>
            </div>
          </div>
        </nav> */}

        <div className="hero-content">
          <span className="tag"> {cityDetails?.firstSection?.mainTag}</span>
          <h1>
            {/* Gurugram’s Most <br />{" "}
            <span className="highlight">Powerful Data</span> <br />& Broker
            Platform */}
            {cityDetails?.firstSection?.header
              ?.split(" ")
              .slice(0, 2)
              .join(" ")}{" "}
            <span>
              {cityDetails?.firstSection?.header
                ?.split(" ")
                .slice(2, 4)
                .join(" ")}{" "}
            </span>
            {cityDetails?.firstSection?.header?.split(" ").slice(4).join(" ")}
          </h1>
          <p className="sub-text">
            {/* Verified Owner Data • Direct Builder Connections • High-Quality
            Inventory for Serious Brokers. Close deals faster and grow without
            limits. */}
            {cityDetails?.firstSection?.descriptions?.map((e, i) => {
              return <span key={i}>{e} • </span>;
            })}
          </p>

          <div className="buttons">
            <button
              className="primary"
              onClick={() => {
                navigate("/profile");
              }}
            >
              Register Now →
            </button>
            <button className="secondary">Learn More</button>
          </div>

          <div className="features">
            {/* <div className="feat_icon">
              <span>✔</span> Verified Owner Data
            </div>
            <div className="feat_icon">
              <span>✔</span> Direct Builder Tie-ups
            </div>
            <div className="feat_icon">
              <span>✔</span> 100% Genuine Inventory
            </div> */}
            {cityDetails?.firstSection?.tags?.map((e, i) => {
              return (
                <div className="feat_icon">
                  <span>
                    <img
                      src={e?.icon}
                      style={{
                        height: "16px",
                        width: "16px",
                        display: "block",
                        margin: "auto",
                      }}
                      alt=""
                    />
                  </span>{" "}
                  {e?.content}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="spc-wrp-for-city">
        <AdvertisingBanner />
      </div>

      <ExploreTopCities />
      <LocationInsig />
      {/* 2nd section */}

      {0 === 1 && (
        <>
          <div className="second_section">
            <div className="header-row">
              <div className="title">
                <div className="icon-circle">G</div>
                <h2>{cityDetails?.cityData?.name}</h2>
              </div>
              <button className="explore-btn">Explore Data ▴</button>
            </div>
            <div className="gurgaon-wrapper">
              <div className="info-grid">
                <div className="overview-box">
                  <div className="overview-icon">
                    <img
                      style={{ height: "30px", width: "30px" }}
                      src={cityDetails?.mapSection?.icon}
                      alt=""
                    />
                  </div>
                  <h3 className="overview-icon-h3">
                    {cityDetails?.mapSection?.heading}
                  </h3>
                  <p className="overview-icon-p">
                    {cityDetails?.mapSection?.desc}
                  </p>
                  <a
                    target="_blank"
                    href={cityDetails?.mapSection?.url}
                    className="map-link"
                  >
                    View Map <span>→</span>
                  </a>
                </div>

                <div className="info-column">
                  <h4 className="infoh4">
                    {/* <i class="fa-solid fa-location-dot"></i> */}
                    <span>
                      <img
                        style={{ width: "20px", height: "20px" }}
                        src={cityDetails?.secondSection?.locality?.icon}
                      ></img>
                    </span>
                    Localities
                  </h4>
                  <ul>
                    {/* <li>DLF Phase 1</li>
                <li>DLF Phase 2</li>
                <li>DLF Phase 3</li>
                <li>DLF Phase 4</li>
                <li>Sushant Lok 1</li> */}
                    {cityDetails?.localityData?.map((e, i) => {
                      return <li>{e?.name}</li>;
                    })}
                  </ul>
                </div>

                <div className="info-column">
                  <h4 className="infoh4">
                    {/* <i class="fa-regular fa-building"></i>  */}
                    <span>
                      <img
                        style={{ width: "20px", height: "20px" }}
                        src={cityDetails?.secondSection?.appartment?.icon}
                      ></img>
                    </span>
                    Apartments
                  </h4>
                  <ul>
                    {/* <li>DLF The Crest</li>
                <li>DLF The Aralias</li>
                <li>DLF The Magnolias</li>
                <li>DLF The Camellias</li>
                <li>M3M Golf Estate</li> */}
                    {cityDetails?.appartmentData?.map((e, i) => {
                      return <li>{e?.aptName}</li>;
                    })}
                  </ul>
                </div>

                <div className="info-column">
                  <h4 className="infoh4">
                    {/* <i class="fa-solid fa-store"></i> */}
                    <span>
                      <img
                        style={{ width: "20px", height: "20px" }}
                        src={cityDetails?.secondSection?.commercial?.icon}
                      ></img>
                    </span>
                    Commercial
                  </h4>
                  <ul>
                    {/* <li>Udyog Vihar</li>
                <li>DPace City</li>
                <li>Sector 30</li>
                <li>Cyber City</li>
                <li>Golf Course Road</li> */}
                    {cityDetails?.secondSection?.commercial?.items?.map(
                      (e, i) => {
                        return <li>{e}</li>;
                      },
                    )}
                  </ul>
                </div>
              </div>

              <div className="highlight-header">
                <h3 className="infoh4">
                  📸 {cityDetails?.cityData?.name} Highlights & Partners
                </h3>
                <a href="#" className="view-all">
                  View All
                </a>
              </div>

              <div className="highlight-cards">
                {reelsForCity?.map((e, i) => {
                  return (
                    <div className="card">
                      <img src={e?.thumbnail} alt="" />
                    </div>
                  );
                })}
                {/* <div className="card">
              <img src="houseinside1.jpg" alt="" />
            </div>
            <div className="card">
              <img src="houseinside2.jpg" alt="" />
            </div>
            <div className="card">
              <img src="sunset.jpg" alt="" />
            </div> */}

                <div className="partner-box">
                  <div className="partner-icon">🏢</div>
                  <p className="partner-title">Become a Partner</p>
                  <p className="partner-sub">Showcase your brand here</p>
                </div>
              </div>
            </div>
          </div>

          {/* 3rd section start */}

          <div className="gurgaon-lead">
            <div className="gurgaon-under">
              <div className="gurgaon-under_left">
                <div
                  className="gargaon_card1"
                  style={{
                    background: `url(${cityDetails?.thirdSection?.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    // objectFit: "cover",
                  }}
                >
                  <h2>Since 2000</h2>
                  <p>serving the Industry</p>
                </div>
              </div>
              <div className="gurgaon-under_right">
                <div className="garga_h2">
                  {/* <h2 className="garga_h2_h1">Gurugram's Leading</h2>
              <h2 className="garga_h2_h2">Real Estate Data provider</h2> */}
                  <h2 className="garga_h2_h2">
                    <span>
                      {cityDetails?.thirdSection?.heading
                        ?.split(" ")
                        .slice(0, 2)
                        .join(" ")}
                    </span>
                    {cityDetails?.thirdSection?.heading
                      ?.split(" ")
                      .slice(2)
                      .join(" ")}
                  </h2>
                  <div className="garga_para">
                    <p>
                      {/* we are a premium B2B real easte data provider and broker
                  platform ,built to help brokers scale fast,work smart,and
                  close deals with confidents. */}
                      {cityDetails?.thirdSection?.desc}
                    </p>
                  </div>
                  <div className="garga_list">
                    {/* <p className="garga_list_p">
                  <i class="fa-regular fa-user"></i> Most reliable real estate
                  data in Gurugram,Noida & South Delhi.
                </p>
                <p className="garga_list_p">
                  <i class="fa-solid fa-magnifying-glass"></i>
                  Verified,Updated,and ready for action inventory.
                </p> */}
                    {cityDetails?.thirdSection?.points?.map((e, i) => {
                      return (
                        <p className="garga_list_p">
                          <img
                            style={{ height: "20px", width: "20px" }}
                            alt={i}
                            src={e?.icon}
                          ></img>{" "}
                          {e?.content}
                        </p>
                      );
                    })}
                  </div>
                </div>
                <button
                  onClick={() => {
                    navigate("/aboutus");
                  }}
                  className="gargabtn"
                >
                  Learn More About Us
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* 4th section start */}
      <div className="problems-section">
        <div className="problem_div">
          <h2 className="main-title">
            {/* {" "}
            Why Most Brokers in{" "}
            <span className="blue-text">Gurugram Struggle</span> */}

            <span className="blue-text">
              <span>
                {cityDetails?.fourthSection?.heading
                  ?.split(" ")
                  .slice(0, 4)
                  .join(" ")}{" "}
              </span>
              {cityDetails?.fourthSection?.heading
                ?.split(" ")
                .slice(4)
                .join(" ")}
            </span>
          </h2>
          <p className="subtitle">
            {/* {" "}
            The market has evolved, but your data hasn’t. Stop working with
            outdated information.{" "} */}
            {cityDetails?.fourthSection?.subHeading}
          </p>
          <div className="problemscards_sec">
            {" "}
            {cityDetails?.fourthSection?.sections.map((item) => (
              <div key={item.id} className="problem-card">
                <div className="icon">
                  <img
                    style={{ height: "30px", width: "30px" }}
                    src={item?.icon}
                  ></img>
                </div>
                <div className="problem_para">
                  <h4>{item?.header}</h4>
                  <p>{item?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* testimonial section */}
      {/* <div className="testimonial-section">
        <h2 className="ts-title">What Our Customers Say</h2>

        <div className="slider-container">
          <button className="prev-btn" onClick={prevSlide}>
            ❮
          </button>

          <div className="testimonial-card">
            <img
              src={testimonials[index].image}
              alt="User"
              className="profile-img"
            />

            <p className="review-text">"{testimonials[index].review}"</p>

            <h4 className="reviewer-name">{testimonials[index].name}</h4>
            <span className="reviewer-role">{testimonials[index].role}</span>
          </div>

          <button className="next-btn" onClick={nextSlide}>
            ❯
          </button>
        </div>

        
        <div className="dots">
          {testimonials.map((_, i) => (
            <span
              key={i}
              className={i === index ? "dot active" : "dot"}
              onClick={() => setIndex(i)}
            ></span>
          ))}
        </div>
      </div> */}
      {/* 6th section start */}
      <div className="problems-section2">
        <h2 className="main-title22">
          {cityDetails?.fifthSection?.heading}
          {/* What Successful Brokers <span className="blue-text">Really Need</span> */}
        </h2>
        <p className="subtitle22">
          {cityDetails?.fifthSection?.desc}
          {/* Thewinners2.in gives you the unfair adavantage with the best sysytem,
          better data,and <br />
          faster access.{" "} */}
        </p>
        <div className="problemscards_sec">
          {" "}
          {cityDetails?.fifthSection?.sections?.map((item) => (
            <div key={item.id} className="problem-card22">
              <div className="icon">
                <img
                  style={{ height: "30px", width: "30px" }}
                  src={item?.icon}
                ></img>
              </div>
              <div className="problem_para22">
                <h4>{item?.heading}</h4>
                <p>{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* 7th section start */}
      <div className="howitworks-section">
        <div className="stats-container">
          {cityDetails?.seventhSection?.counts?.map((item, index) => (
            <div key={index} className="stat-box">
              <h2>{item?.heading}</h2>
              <p>{item?.subHeading}</p>
            </div>
          ))}
        </div>
        <div className="how-content">
          <div className="contant_title">
            <h2 className="titleh2">
              {cityDetails?.seventhSection?.midHeading}
            </h2>
            <p className="subtitle">
              {cityDetails?.seventhSection?.midSubHeading}
            </p>
          </div>

          <div className="steps-container">
            {cityDetails?.seventhSection?.works?.map((step, index) => (
              <div key={index} className="step-card">
                <div className="step-icon">
                  <img
                    style={{ height: "30px", width: "30px" }}
                    src={step?.icon}
                  ></img>
                </div>
                <h4>{step?.heading}</h4>
                <p>{step?.subheading}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="gurgaon-lead">
          <div className="gurgaon-under">
            <div className="gurgaon-under_left">
              <div
                className="gargaon_card1"
                style={{
                  background: `url(${cityDetails?.thirdSection?.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <h2>Since 2000</h2>
                <p>serving the Industry</p>
              </div>
            </div>
            <div className="gurgaon-under_right">
              <div className="garga_h2">
                {/* <h2 className="garga_h2_h1">Gurugram's Leading</h2>
              <h2 className="garga_h2_h2">Real Estate Data provider</h2> */}
                <h2 className="garga_h2_h2">
                  <span>
                    {cityDetails?.thirdSection?.heading
                      ?.split(" ")
                      .slice(0, 2)
                      .join(" ")}{" "}
                  </span>
                  {cityDetails?.thirdSection?.heading
                    ?.split(" ")
                    .slice(2)
                    .join(" ")}
                </h2>
                <div className="garga_para">
                  <p>
                    {/* we are a premium B2B real easte data provider and broker
                  platform ,built to help brokers scale fast,work smart,and
                  close deals with confidents. */}
                    {cityDetails?.thirdSection?.desc}
                  </p>
                </div>
                <div className="garga_list">
                  {/* <p className="garga_list_p">
                  <i class="fa-regular fa-user"></i> Most reliable real estate
                  data in Gurugram,Noida & South Delhi.
                </p>
                <p className="garga_list_p">
                  <i class="fa-solid fa-magnifying-glass"></i>
                  Verified,Updated,and ready for action inventory.
                </p> */}
                  {cityDetails?.thirdSection?.points?.map((e, i) => {
                    return (
                      <p className="garga_list_p">
                        <img
                          style={{ height: "20px", width: "20px" }}
                          alt={i}
                          src={e?.icon}
                        ></img>{" "}
                        {e?.content}
                      </p>
                    );
                  })}
                </div>
              </div>
              <button
                onClick={() => {
                  navigate("/aboutus");
                }}
                className="gargabtn"
              >
                Learn More About Us
              </button>
            </div>
          </div>
        </div>

        {/* <AboutCommunity /> */}
      </div>
      {/* 8th section start */}
      <div className="mobile_section">
        <div className="mange_section_left" style={{ width: "65%" }}>
          <h2 className="mange_h1">{cityDetails?.eighthSection?.heading}</h2>
          <h2 className="mange_h2">On The Go</h2>
          <p className="mange_para">
            {/* India's largest Brokers platform on mobile. Manage your entire
            business from anywhere: track listings, manage leads, and close
            deals right from your pocket */}
            {cityDetails?.eighthSection?.description}
          </p>
          <div className="img">
            <a href={cityDetails?.eighthSection?.playStore}>
              <img src="gicon.png" alt="" />
            </a>
            <a href={cityDetails?.eighthSection?.appStore}>
              {" "}
              <img src="aicon.jpg" alt="" />
            </a>
          </div>
        </div>
        <div className="mange_section_right" style={{ width: "35%" }}>
          {/* <img src="./mobile.avif" alt="" /> */}
          <img
            src={cityDetails?.eighthSection?.image}
            style={{ height: "750px", width: "100%" }}
            alt=""
          />
        </div>
      </div>

      {/* footer section */}
      <footer className="footer-section">
        <div className="footer-cta">
          <h2>{cityDetails?.ninethSection?.heading}</h2>
          <p>{cityDetails?.ninethSection?.desc}</p>

          <button
            className="register-btn"
            onClick={() => {
              navigate("/profile");
            }}
          >
            Register Now
          </button>
        </div>

        <div className="footer-main">
          <div className="footer-left">
            <h3 className="brand">
              TheWinners2 <span>.in</span>
            </h3>
            <p className="brand-text">
              Gurugram’s most powerful real estate data & broker platform.
              Helping brokers close deals faster with verified data.
            </p>

            <div className="social-icons">
              <img src="fb.webp" alt="" />
              <img src="twitter.png" alt="" />
            </div>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li>Home</li>
              <li>Services</li>
              <li>About Us</li>
              <li>Contact</li>
            </ul>
          </div>

          <div className="footer-legal">
            <h4>Legal</h4>
            <ul>
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 TheWinners2.in. All rights reserved.</p>
          <p>Designed for Broker Success.</p>
        </div>
      </footer>
    </div>
  );
}

export default CityPage;
